import React, { Component } from 'react';
import { Button, ButtonToolbar, FormControl } from 'react-bootstrap';

class SpendForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      amount: 0
    };
  }

  handleSpend() {
    let amount = this.state.amount;
    this.setState({amount: 0});
    this.props.onSpend(amount);
  }

  handleChange(e) {
    this.setState({amount: parseInt(e.target.value, 10) });
  }

  render() {
    return (
      <div>
        <FormControl type='number' value={this.state.amount} onChange={e => this.handleChange(e)} />
        <Button onClick={() => this.handleSpend()}>Spend</Button>
      </div>
    )
  }
}

const SpendBar = ({budget, total, ...props}) => {
  const barWidthFactor = (budget - total) / budget;

  const style = {
    width: barWidthFactor * 100 + '%'
  };

  return (
    <div className='SpendBar' style={style} />
  )
}

const SpendButton = ({amount, onClick, ...props}) => {
  return (
    <Button bsStyle='primary' onClick={onClick}>+{amount}</Button>
  )
}

const SpendButtonRow = ({amounts, onTotalChanged, total, ...props}) => {
  const buttons = amounts.map((a, i) => (
    <SpendButton key={i} amount={a} onClick={() => onTotalChanged(total + a)} />
  ));

  return (
    <ButtonToolbar className='ButtonToolbar'>
      {buttons}
    </ButtonToolbar>
  )
}

const MoneyCounter = ({budget, total, onTotalChanged, onReset, ...props}) => (
  <div>
    <div className='MoneyCounterText'>{total}/{budget}</div>
    <SpendBar budget={budget} total={total} />
    <span>
      <SpendButtonRow amounts={[50, 100, 200, 500, 1000]} onTotalChanged={onTotalChanged} total={total} />
      <SpendForm onSpend={amount => onTotalChanged(total + amount)} />
    </span>
    <Button style={{margin: '10px'}} bsStyle='danger' onClick={onReset}>Reset</Button>
  </div>
)

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      budget: 7000,
      total: 0
    };
  }

  componentWillMount() {
    this.props.db.ref('total').on('value', snapshot => {
      this.setState({total: snapshot.val()});
    });
  }

  setTotal(newTotal) {
    this.props.db.ref('total').set(newTotal);
  }

  render() {
    return (
      <div>
        <MoneyCounter
          budget={this.state.budget}
          total={this.state.total}
          onTotalChanged={newTotal => this.setTotal(newTotal)}
          onReset={() => this.setTotal(0)} />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx